import { Download, FileSignature, RotateCw } from "lucide-react";
import { downloadRrhhContract } from "../api/rrhh";
import type { RrhhContract } from "../types/rrhh";

type Props = {
  contracts: RrhhContract[];
  loading: boolean;
  onReload: () => Promise<void> | void;
};

export function ContractsPanel({ contracts, loading, onReload }: Props) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="rrhh-panel-header">
        <div className="relative flex items-start justify-between gap-4">
          <div className="flex items-center gap-4">
            <span className="rrhh-panel-icon">
              <FileSignature size={22} />
            </span>

            <div>
            <div className="text-xs font-black uppercase tracking-[0.18em] text-emerald-600">
              Archivo laboral
            </div>

            <h2 className="mt-1 text-2xl font-black tracking-tight text-slate-950">
              Documentación
            </h2>

            <p className="mt-1 text-sm font-semibold leading-6 text-slate-500">
              Documentos relacionados con tu contrato.
            </p>
            </div>
          </div>

          <button
            type="button"
            onClick={() => void onReload()}
            disabled={loading}
            className="rrhh-soft-button"
          >
            <RotateCw size={15} className={loading ? "animate-spin" : ""} />
            Actualizar
          </button>
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-auto p-5">
        {loading ? (
          <EmptyText text="Cargando documentación..." />
        ) : contracts.length === 0 ? (
          <EmptyText text="No hay documentos de contratación disponibles." />
        ) : (
          <div className="space-y-3">
            {contracts.map((contract) => (
              <div
                key={contract.id}
                className="rrhh-document-row flex items-center justify-between gap-4"
              >
                <div className="flex min-w-0 flex-1 items-center gap-3">
                  <span className="rrhh-document-icon">
                    <FileSignature size={19} />
                  </span>
                  <div className="min-w-0">
                    <div className="truncate font-black text-slate-900">
                      {contract.nombre_archivo}
                    </div>
                    <div className="text-sm font-semibold text-slate-500">
                      Subido el {formatDate(contract.fecha_subida)}
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => void downloadRrhhContract(contract.id)}
                  className="rrhh-primary-button shrink-0"
                >
                  <Download size={17} />
                  Descargar
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function EmptyText({ text }: { text: string }) {
  return <div className="rrhh-empty-state">{text}</div>;
}

function formatDate(value: string) {
  return new Date(value).toLocaleDateString("es-ES");
}

